export const yearOptions = (minYear) => {
  return Array(new Date().getFullYear() - minYear + 2) // +2 to get this & next year
    .fill(null)
    .map((_, index) => {
      const year = minYear + index;
      return { id: year, value: year.toString() };
    })
    .reverse();
};
